export const UNEXPECTED_ERROR = 'Unexpected error';
export enum SubscriptionToasterMsg {
  CREATE_SUBSCRIPTION_SUCCEED = 'Subscription created',
  UPDATE_SUBSCRIPTION_SUCCEED = 'Subscription updated',
}

export enum UserToasterMsg {
  UPDATE_USER_DETAIL_SUCCEED = 'User detail updated',
  DELETE_USER_SUCCEED = 'User deleted successfully',
  ACTIVATE_USER_SUCCEED = 'User activated successfully',
  DEACTIVATE_USER_SUCCEED = 'User deactivated successfully',
}

export enum CompanyToasterMsg {
  UPDATE_COMPANY_DETAIL_SUCCEED = 'Company detail updated',
  CREATE_COMPANY_SUCCEED = 'Company created',
  DELETE_COMPANY_SUCCEED = 'Company deleted',
}

export enum PortfolioToasterMsg {
  MOVE_SUBSCRIPTION_SUCCEED = 'Subscription updated',
  PORTFOLIO_OUT_OF_USAGE = 'Portfolio is out of usage',
}
